import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { enableProdMode, isDevMode } from '@angular/core';
import { environment } from './environments/environment';
import { TerminalVersionSHA } from './app/version.constant';

if (environment.production) {
  enableProdMode();
}

if (!isDevMode()) {
  console.log('Production mode enabled');
}

Sentry.init({
  release: TerminalVersionSHA,
  enabled: !isDevMode(),
  dsn: 'https://ad040ba0271d923d58d1a5584b62c94a@o4509973761228800.ingest.de.sentry.io/4510295200301136',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.httpClientIntegration(),
    Sentry.replayIntegration({
      // Additional SDK configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  tracePropagationTargets: [
    'localhost',
    'https://terminal.gp2.app',
    /^https:\/\/pt[0-9]+\.gp2\.app\/api/,
  ],
});

if (Sentry.getClient()?.getOptions().enabled) {
  console.log('Sentry is enabled');
} else {
  console.log('Sentry is disabled');
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
